import HttpService from '../HttpService'

export default class InvoiceService {
  constructor() {
    this._httpService = new HttpService('/invoice-service/rule');
  }

  async GetInvoiceRuleTypes() {
    return await this._httpService.get(`/config/rule-types`);
  }

  async GetInvoiceValueTypes() {
    return await this._httpService.get(`/config/value-types`);
  }

  async GetInvoiceRuleConfigs(params) {
    return await this._httpService.get(`/config${params ? `?${params}` : ''}`);
  }

  async PostInvoiceRuleConfig(payload) {
    return await this._httpService.post(`/config`, payload);
  }

  async UpdateInvoiceRuleConfig(ruleId, payload) {
    return await this._httpService.put(`/config/${ruleId}`, payload);
  }

  async UnlinkInvoiceRuleConfig(ruleId) {
    return await this._httpService.delete(`/config/${ruleId}`);
  }
}
